var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningStorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.476 25.343 c -0.034 -0.513 -0.058 -1.029 -0.058 -1.55 c 0 -12.714 10.307 -23.021 23.021 -23.021 c 9.198 0 17.133 5.396 20.82 13.193 c 2.777 -1.972 6.162 -3.142 9.827 -3.142 c 8.48 0 15.49 6.212 16.778 14.329 C 85.703 26.749 90 32.078 90 38.424 c 0 7.607 -6.167 13.774 -13.774 13.774 H 13.774 C 6.167 52.197 0 46.031 0 38.424 C 0 32.319 3.976 27.15 9.476 25.343 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(98,195,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.733 71.819 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.533 0.763 -0.819 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 11.554 71.554 11.157 71.819 10.733 71.819 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.385 90.228 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.763 -0.819 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 5.206 89.963 4.81 90.228 4.385 90.228 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.433 82.047 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.761 -0.82 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 L 18.4 81.357 C 18.254 81.781 17.858 82.047 17.433 82.047 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.84 90.228 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.763 -0.819 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 25.661 89.963 25.264 90.228 24.84 90.228 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.888 82.047 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.761 -0.82 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 38.709 81.781 38.312 82.047 37.888 82.047 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.642 71.819 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.184 -0.534 0.764 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 52.463 71.554 52.066 71.819 51.642 71.819 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.294 90.228 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.184 -0.534 0.765 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 46.115 89.963 45.719 90.228 45.294 90.228 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.342 82.047 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.292 -9.546 c 0.184 -0.533 0.764 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.292 9.546 C 59.163 81.781 58.767 82.047 58.342 82.047 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.096 71.819 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.184 -0.534 0.766 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 72.917 71.554 72.521 71.819 72.096 71.819 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.749 90.228 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.184 -0.534 0.766 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 66.57 89.963 66.174 90.228 65.749 90.228 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "37.38,31.62 32.02,46.47 39.43,46.47 31.68,68.59 58.32,39.98 49.07,40.19 54.6,31.62 37.38,31.62 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(249,193,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningStorm);
export default __webpack_public_path__ + "static/media/lightning-storm.d9f60ee5fc82c3195c19ee265b217942.svg";
export { ForwardRef as ReactComponent };